import React from 'react';
import {
  ListItemButton,
  ListItemAvatar,
  ListItemText,
  Avatar,
  ListItem,
  Checkbox,
  useTheme,
} from '@mui/material';

const CustomerMassiveItem = function CustomerMassiveItem({
  recipient,
  selected = false,
  checked = false,
  messageAlreadySent = false,
  onClick,
  onClickCheckbox,
}) {
  const theme = useTheme();
  const { id, fullName, contact } = recipient;

  return (
    <ListItem
      disablePadding
      secondaryAction={
        !messageAlreadySent ? (
          <Checkbox
            edge="end"
            onChange={onClickCheckbox}
            checked={checked}
            value={id}
          />
        ) : null
      }
    >
      <ListItemButton selected={selected} onClick={() => onClick(recipient)}>
        <ListItemAvatar>
          <Avatar
            sx={theme.custom.bgAndColorStyle(
              theme.custom.stringToColor(fullName),
              theme.palette.mode
            )}
          >
            {fullName?.trim()?.[0]?.toUpperCase()}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={fullName}
          secondary={contact}
          slotProps={{
            primary: { noWrap: true },
            secondary: { noWrap: true, sx: { color: 'inherit', opacity: 0.7 } },
          }}
        />
      </ListItemButton>
    </ListItem>
  );
};

export default CustomerMassiveItem;
